import { type Chain, PluginBase } from '@goat-sdk/core';
import type { EVMWalletClient } from '@goat-sdk/wallet-evm';
import { mode } from 'viem/chains';
import { ModeGovernanceService } from './mode-governance.service';
import { CommonParameters } from 'mode-shared/types/common';

const SUPPORTED_CHAINS = [mode];

export class ModeGovernancePlugin extends PluginBase<EVMWalletClient> {
  constructor(params: CommonParameters) {
    super('mode-governance', [new ModeGovernanceService(params)]);
  }

  supportsChain = (chain: Chain) => chain.type === 'evm' && SUPPORTED_CHAINS.some((c) => c.id === chain.id);
}

const modeGovernance = (params: CommonParameters) => new ModeGovernancePlugin(params);

export default modeGovernance;
